/* ============================================================
   Wild & Crisp — storefront behaviour
   Cart drawer, add-to-cart, BYOB builder, toasts, reveal.
   Talks to Shopify's real AJAX cart API.
   ============================================================ */
(function () {
  'use strict';

  var FREE_SHIP = 49900; // paise — free shipping at ₹499

  /* ---------- helpers ---------- */
  function money(paise) {
    var r = (paise || 0) / 100;
    return '₹' + Math.round(r).toLocaleString('en-IN');
  }
  function emojiFor(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('mango') > -1) return '🥭';
    if (t.indexOf('pine') > -1) return '🍍';
    if (t.indexOf('chickoo') > -1 || t.indexOf('sapota') > -1) return '🟤';
    if (t.indexOf('banana') > -1) return '🍌';
    if (t.indexOf('sampler') > -1 || t.indexOf('try') > -1) return '🎁';
    return '🍈';
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toasts ---------- */
  function toast(msg, type) {
    var wrap = $('.wac-toasts');
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'wac-toasts'; document.body.appendChild(wrap); }
    var t = document.createElement('div');
    t.className = 'wac-toast' + (type ? ' ' + type : '');
    t.textContent = msg;
    wrap.appendChild(t);
    setTimeout(function () { t.style.transition = 'opacity .3s'; t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 320); }, 2200);
  }

  /* ---------- cart drawer ---------- */
  function openDrawer() {
    var d = $('.wac-drawer'), o = $('.wac-overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('.wac-drawer'), o = $('.wac-overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ---------- prepaid slabs: the nudge in the cart ----------
     The checkout takes a percentage off the whole cart on orders paid in full
     online; the slabs are bands of cart value. They are read from
     data-wac-tiers on the drawer ("from:to:percent" in whole rupees, lowest
     first, "to" 0 = no upper limit), which the Liquid side prints from
     snippets/wac-prepaid.liquid, so nothing about them is hardcoded here.

     The cart only nudges: it says how much more reaches the next slab. It never
     changes a price, because the discount is the checkout's to apply. Without
     the attribute, or with an empty cart, it prints nothing at all. */
  function slabTiers() {
    var el = $('[data-wac-tiers]'), out = [];
    ((el && el.getAttribute('data-wac-tiers')) || '').split(',').forEach(function (t) {
      var p = t.split(':'), lo = Number(p[0]), hi = Number(p[1]), pct = Number(p[2]);
      if (!(lo > 0) || !(pct > 0)) return;
      // a slab runs from ₹lo.00 to ₹hi.99; hi 0 means there is no upper limit
      out.push({ lo: lo * 100, hi: hi > 0 ? hi * 100 + 99 : Infinity, pct: pct });
    });
    out.sort(function (a, b) { return a.lo - b.lo; });
    return out;
  }
  function slabHtml(total) {
    var tiers = slabTiers();
    if (!tiers.length || !(total > 0)) return '';
    var cur = null, next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total >= tiers[i].lo && total <= tiers[i].hi) cur = tiers[i];
      if (!next && total < tiers[i].lo) next = tiers[i];
    }
    var txt, w;
    if (next) {
      txt = cur
        ? '<span>🎉 <b>' + cur.pct + '% off</b> unlocked</span><span>Add ' + money(next.lo - total) + ' more for <b>' + next.pct + '% off</b></span>'
        : 'Add ' + money(next.lo - total) + ' more to get <b>' + next.pct + '% off</b>';
      // the bar fills towards the NEXT slab, so there is always something to aim at
      // never quite full while there is still a rupee to go
      w = Math.max(4, Math.min(97, Math.round(total / next.lo * 100)));
    } else if (cur) {
      txt = '<span>🎉 You’ve unlocked <b>' + cur.pct + '% off</b></span><span>That is our biggest saving</span>';
      w = 100;
    } else {
      return '';
    }
    return '<div class="slab"><div class="txt">' + txt + '</div>' +
      '<div class="meter"><i style="width:' + w + '%"></i></div>' +
      '<div class="sub">Prepaid orders · applied at checkout</div></div>';
  }

  function renderCart(cart) {
    // count badges
    $all('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    });

    // the cart PAGE has its own copy of the slab nudge (the drawer's is built below)
    $all('[data-wac-slab]').forEach(function (el) {
      el.innerHTML = cart.items.length ? slabHtml(cart.total_price) : '';
    });

    var itemsEl = $('.wac-drawer .drawer-items');
    var footEl = $('.wac-drawer .drawer-foot');
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty"><span class="em">🧺</span><p>Your cart is empty.<br>Add some crunch!</p></div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = 'flex';

    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      return '<div class="cart-item">' +
        (img ? '<img class="ci-img" src="' + img + '" alt="" loading="lazy">' : '<span class="em">' + emojiFor(it.product_title || it.title) + '</span>') +
        '<div class="ci-info">' +
          '<div class="ci-name">' + (it.product_title || it.title) + '</div>' +
          '<div class="ci-detail">Qty ' + it.quantity + ' · ' + money(it.final_price) + ' each</div>' +
        '</div>' +
        (it.line_level_total_discount > 0
          ? '<span class="ci-price saved"><s class="ci-was">' + money(it.original_line_price) + '</s>' + money(it.final_line_price) + '</span>'
          : '<span class="ci-price">' + money(it.final_line_price) + '</span>') +
        '<button class="ci-x" data-wac-remove="' + it.key + '" aria-label="Remove">✕</button>' +
      '</div>';
    }).join('');

    // free-ship meter + totals
    var remaining = FREE_SHIP - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / FREE_SHIP) * 100));
    var meterTxt = remaining > 0
      ? 'Add ' + money(remaining) + ' more for FREE shipping 🚚'
      : 'You’ve unlocked FREE shipping! 🎉';

    /* The box discount is product-targeted, so Shopify allocates it at LINE
       level and cart.discount_applications comes back EMPTY — verified against
       a real cart, not assumed. The money is in cart.total_discount and in each
       item's line_level_total_discount. original_total_price - total_price is
       used here because it stays right whichever way a future discount
       allocates. */
    var disc = (cart.original_total_price || cart.total_price) - cart.total_price;

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    // Shopify stamps the discount's own name onto the allocation, so the cart
    // can say "Build a box — 5% off 3+ pouches" instead of a bare "Discount".
    function discountTitle() {
      for (var i = 0; i < cart.items.length; i++) {
        var a = cart.items[i].line_level_discount_allocations || [];
        if (a.length && a[0].discount_application && a[0].discount_application.title) {
          return a[0].discount_application.title;
        }
      }
      var c = cart.cart_level_discount_applications || [];
      if (c.length) return (c[0].discount_application && c[0].discount_application.title) || c[0].title || 'Discount';
      return 'Discount';
    }

    var totalsHtml = disc > 0
      ? '<div class="row sub"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>' +
        '<div class="row save"><span class="lbl"><span class="tag">SAVING</span><b>' + esc(discountTitle()) + '</b></span>' +
          '<span>−' + money(disc) + '</span></div>' +
        '<div class="row grand"><span>Total</span><span>' + money(cart.total_price) + '</span></div>'
      : '<div class="row grand"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>';

    // The checkout control is a <form action="/cart"> + <button name="checkout">
    // rather than an <a href="/checkout">: that is the standard Shopify cart
    // markup Razorpay Magic Checkout auto-detects, and it is why the Cart
    // Selector field in the Razorpay dashboard could be left empty. With the
    // app off it still posts to /cart and Shopify redirects to the normal
    // checkout, so the no-Razorpay fallback is unchanged.
    //
    // THE LITERAL ARROW STAYS HERE. The drawer is a sibling of
    // <header class="wac wac-header">, not a child of any .wac wrapper, so
    // `.wac .btn::after` (wac-launch.css:28) never reaches it and nothing
    // injects one. The cart page's copy of this button IS inside .wac and
    // therefore carries no literal arrow. Do not "make them consistent".
    //
    // Shopflo integration. The <form> wrapper stays exactly where it was —
    // `.wac-drawer .drawer-foot form{margin:0}` (wac-header.liquid:107) zeroes
    // a UA margin that the .drawer-foot 10px gap rhythm depends on, so dropping
    // the form would shift the whole footer. The replacement is type="button",
    // so it never submits; the bundle takes the click instead. The literal
    // arrow STAYS, per the note above — this copy is outside .wac.
    footEl.innerHTML =
      slabHtml(cart.total_price) +
      '<div class="ship-meter"><div class="txt">' + meterTxt + '</div>' +
        '<div class="meter"><i style="width:' + pct + '%"></i></div></div>' +
      '<div class="totals">' + totalsHtml + '</div>' +
      '<form action="/cart" method="post" novalidate>' +
        // Original checkout button — commented out for Shopflo integration
        // '<button type="submit" name="checkout" class="btn">Checkout →</button>' +
        '<button type="button" id="checkout2" name="checkout2" class="btn" ' +
          'onclick="handleFloCheckoutBtn()">Checkout →</button>' +
      '</form>';
  }

  function refreshCart(opts) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (opts && opts.open) openDrawer(); return cart; });
  }

  function addToCart(items, opts) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      return refreshCart({ open: true });
    }).then(function () {
      if (opts && opts.toast) toast(opts.toast, 'ok');
    }).catch(function (e) {
      toast((e && e.description) || 'Could not add to cart', 'warn');
    });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------- BYOB ----------
     There is no box "size". The builder just counts pouches and lights the
     milestones up as they are crossed.

     Both milestones are measured in MONEY (since 10 Oct 2026):
       - the discount is the store-wide prepaid offer. Its tiers are bands of
         order value, read from data-byob-tiers ("from:to:percent" in whole
         rupees, lowest first, "to" 0 = no upper limit), which the Liquid side
         prints from snippets/wac-prepaid.liquid. Nothing about the tiers is
         hardcoded here.
       - free shipping is measured against the box's value AFTER the prepaid
         saving — the cautious figure, so the meter never promises free
         shipping the checkout might not give.

     The theme does not apply the discount. The checkout does, and only on
     orders paid in full online, so the bar keeps showing the full total (what
     the cart will show) with the prepaid figure beside it. */
  var byob = { counts: {} };
  function byobRoot() { return $('[data-wac-byob]'); }
  function byobTotal() {
    var n = 0; for (var k in byob.counts) n += byob.counts[k]; return n;
  }
  // Paise are shown only when there are any: ₹544.05, but ₹41 rather than ₹41.00.
  function byobRupees(paise) {
    if (paise % 100 === 0) return money(paise);
    return '₹' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function byobCfg(root) {
    var tiers = [];
    (root.getAttribute('data-byob-tiers') || '').split(',').forEach(function (t) {
      var p = t.split(':'), lo = Number(p[0]), hi = Number(p[1]), pct = Number(p[2]);
      if (!(lo > 0) || !(pct > 0)) return;
      // a tier runs from ₹lo.00 to ₹hi.99; hi 0 means there is no upper limit
      tiers.push({ lo: lo * 100, hi: hi > 0 ? hi * 100 + 99 : Infinity, pct: pct });
    });
    tiers.sort(function (a, b) { return a.lo - b.lo; });
    return { tiers: tiers, ship: Number(root.getAttribute('data-byob-ship')) || 0 };
  }
  // The tier this value sits in, or null (below the first tier, or in a gap).
  function byobTier(cfg, gross) {
    for (var i = 0; i < cfg.tiers.length; i++) {
      if (gross >= cfg.tiers[i].lo && gross <= cfg.tiers[i].hi) return cfg.tiers[i];
    }
    return null;
  }
  // The next tier still ahead of this value, or null at the top.
  function byobNext(cfg, gross) {
    for (var i = 0; i < cfg.tiers.length; i++) {
      if (gross < cfg.tiers[i].lo) return cfg.tiers[i];
    }
    return null;
  }
  /* The percentage is taken on the box total. Prices are whole rupees and the
     percentages whole numbers, so the saving is always exact to the paisa. */
  function byobMoney(root, cfg) {
    var gross = 0;
    $all('.byob-row', root).forEach(function (row) {
      var n = byob.counts[row.getAttribute('data-flavour')] || 0;
      if (n > 0) gross += (Number(row.getAttribute('data-price')) || 0) * n;
    });
    var tier = byobTier(cfg, gross), next = byobNext(cfg, gross);
    var save = tier ? Math.round(gross * tier.pct / 100) : 0;
    return { gross: gross, save: save, net: gross - save, tier: tier, next: next };
  }
  function byobRender() {
    var root = byobRoot(); if (!root) return;
    var cfg = byobCfg(root), qty = byobTotal(), m = byobMoney(root, cfg);

    $all('.byob-row', root).forEach(function (row) {
      var val = byob.counts[row.getAttribute('data-flavour')] || 0;
      var valEl = $('.val', row); if (valEl) valEl.textContent = val;
      var minus = $('[data-byob-minus]', row);
      if (minus) minus.disabled = val <= 0;          // plus is never disabled now
      row.classList.toggle('picked', val > 0);
    });

    // The "box" names itself from the count — this is the auto-select.
    var badge = $('[data-wac-byob-count]', root);
    if (badge) {
      badge.textContent = qty === 0 ? 'Empty box' : 'Box of ' + qty;
      badge.classList.toggle('on', !!m.tier);
    }

    // The bar fills towards the NEXT tier, so there is always something to aim
    // at; it is full only once the top tier is reached.
    var gBar = $('[data-byob-goal-bar]', root), gTxt = $('[data-byob-goal-txt]', root);
    if (gBar) {
      gBar.style.width = (m.next
        ? Math.min(100, Math.round(m.gross / m.next.lo * 100))
        : (m.tier ? 100 : 0)) + '%';
    }
    if (gTxt) {
      var first = cfg.tiers[0], txt = '';
      if (qty === 0) {
        if (first) txt = 'Fill your box — ' + first.pct + '% off prepaid starts at ' + money(first.lo);
      } else if (m.tier) {
        txt = m.tier.pct + '% off prepaid — you save ' + byobRupees(m.save) +
          (m.next
            ? ' · ' + byobRupees(m.next.lo - m.gross) + ' more for ' + m.next.pct + '%'
            : ' on this box');
      } else if (m.next) {
        txt = byobRupees(m.next.lo - m.gross) + ' more for ' + m.next.pct + '% off prepaid';
      }
      gTxt.textContent = txt;
      gTxt.classList.toggle('hit', !!m.tier);
    }

    var sBar = $('[data-byob-ship-bar]', root), sTxt = $('[data-byob-ship-txt]', root);
    var shipLeft = cfg.ship - m.net;
    if (sBar) sBar.style.width = (cfg.ship ? Math.min(100, Math.round(m.net / cfg.ship * 100)) : 0) + '%';
    if (sTxt) {
      sTxt.textContent = shipLeft > 0
        ? money(shipLeft > cfg.ship ? cfg.ship : shipLeft) + ' more for free shipping'
        : 'Free shipping unlocked';
      sTxt.classList.toggle('hit', shipLeft <= 0);
    }

    // The main figure is the full price, because that is what the cart shows.
    var totEl = $('[data-byob-total]', root);
    if (totEl) {
      totEl.innerHTML = qty === 0
        ? '<span class="t-now">—</span>'
        : '<span class="t-now">' + money(m.gross) + '</span>' +
          (m.save > 0
            ? '<span class="t-save">Pay online: ' + byobRupees(m.net) + ' · save ' + byobRupees(m.save) + '</span>'
            : '');
    }

    var addBtn = $('[data-wac-byob-add]', root);
    if (addBtn) {
      addBtn.disabled = qty === 0;
      addBtn.textContent = qty === 0
        ? 'Add pouches to start'
        : 'Add ' + qty + ' pouch' + (qty === 1 ? '' : 'es') + ' to cart';
    }
  }
  function byobChange(key, delta) {
    var next = (byob.counts[key] || 0) + delta;
    if (next < 0) next = 0;
    if (next > 99) next = 99;            // sanity ceiling only, not a box rule
    byob.counts[key] = next;
    byobRender();
  }
  function byobAdd() {
    var root = byobRoot(); if (!root) return;
    var qty = byobTotal(); if (qty < 1) return;
    var items = [];
    $all('.byob-row', root).forEach(function (row) {
      var vid = row.getAttribute('data-variant-id');
      var n = byob.counts[row.getAttribute('data-flavour')] || 0;
      // _box records the real count now ("BYOB-5"), because there is no fixed
      // size to record. Same shape as before, so order exports still parse.
      if (n > 0 && vid) items.push({ id: Number(vid), quantity: n, properties: { '_box': 'BYOB-' + qty } });
    });
    if (!items.length) return;
    addToCart(items, { toast: 'Box of ' + qty + ' added! 🎉' });
    byob.counts = {}; byobRender();
  }

  /* ---------- Buy now ----------
     Adds the pouch (at the quantity in the stepper) to the cart and hands
     straight over to the checkout. It calls the same global the two Checkout
     buttons call, so there is one checkout path, not two.

     It deliberately does NOT use the checkout script's own buy-now helper:
     that one needs a product <form>, which these pages do not have, and it
     empties the cart first. Anything already in the cart stays in it here.

     If the checkout script has not loaded, the pouch is still in the cart and
     the drawer opens, so the shopper is never left with nothing happening. */
  var buyBusy = false;
  function buyNow(btn) {
    if (buyBusy) return;
    var vid = Number(btn.getAttribute('data-wac-buynow')); if (!vid) return;
    var qty = 1;
    var scope = btn.closest('[data-wac-scope]');
    var qEl = scope && scope.querySelector('[data-wac-qty]');
    if (qEl) qty = Math.max(1, parseInt(qEl.value, 10) || 1);
    buyBusy = true; btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      if (typeof window.handleFloCheckoutBtn === 'function') window.handleFloCheckoutBtn();
      else { openDrawer(); toast('Added — tap Checkout to pay', 'ok'); }
    }).catch(function (e) {
      toast((e && e.description) || 'Could not add to cart', 'warn');
    }).then(function () {
      buyBusy = false; btn.disabled = false;
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $all('.wac .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var qstep = e.target.closest('[data-wac-qstep]');
    if (qstep) {
      var qbox = qstep.closest('.stepper, .qty');
      var qinp = qbox && qbox.querySelector('[data-wac-qty]');
      if (qinp) { qinp.value = Math.max(1, (parseInt(qinp.value, 10) || 1) + Number(qstep.getAttribute('data-wac-qstep'))); }
      return;
    }
    var bn = e.target.closest('[data-wac-buynow]');
    if (bn) { e.preventDefault(); buyNow(bn); return; }
    var t = e.target.closest('[data-wac-add]');
    if (t) {
      e.preventDefault();
      var vid = Number(t.getAttribute('data-wac-add'));
      var name = t.getAttribute('data-wac-name') || 'Item';
      var qty = 1;
      var scope = t.closest('[data-wac-scope]');
      var qEl = scope && scope.querySelector('[data-wac-qty]');
      if (qEl) qty = Math.max(1, parseInt(qEl.value, 10) || 1);
      if (vid) addToCart([{ id: vid, quantity: qty }], { toast: name + ' added! 🛒' });
      return;
    }
    var lc = e.target.closest('[data-wac-line]');
    if (lc) {
      var lineTo = parseInt(lc.getAttribute('data-wac-qty-to'), 10);
      if (isNaN(lineTo)) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lc.getAttribute('data-wac-line'), quantity: lineTo })
      }).then(function () { location.reload(); });
      return;
    }
    if (e.target.closest('[data-wac-cart-open]')) { e.preventDefault(); refreshCart({ open: true }); return; }
    if (e.target.closest('[data-wac-cart-close]') || e.target.classList.contains('wac-overlay')) { closeDrawer(); return; }
    // Shopflo: the drawer's checkout button opens Shopflo's overlay on top of a
    // drawer that is still open and still holding `body{overflow:hidden}` from
    // openDrawer(). Drop the drawer once the handover has happened, so the
    // scroll lock is released and only one overlay is on screen.
    //
    // This runs at document, i.e. after the button's own inline onclick has
    // already called handleFloCheckoutBtn() — and only if that handler exists,
    // so a click landing before the async bundle is up leaves the drawer open
    // rather than closing onto nothing.
    if (e.target.closest('#checkout2')) {
      if (typeof handleFloCheckoutBtn === 'function') closeDrawer();
      return;
    }
    var rm = e.target.closest('[data-wac-remove]');
    if (rm) { changeQty(rm.getAttribute('data-wac-remove'), 0); return; }
    var bp = e.target.closest('[data-byob-plus]');
    if (bp) { byobChange(bp.closest('.byob-row').getAttribute('data-flavour'), 1); return; }
    var bm = e.target.closest('[data-byob-minus]');
    if (bm) { byobChange(bm.closest('.byob-row').getAttribute('data-flavour'), -1); return; }
    if (e.target.closest('[data-wac-byob-add]')) { byobAdd(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- mobile menu ----------
     The header's Menu button had markup and styles but no behaviour at all, so
     below 880px — where the nav links are hidden — it was a dead control sitting
     next to the cart. The nav is a plain list that `.open` turns into a
     dropdown; all of this is just deciding when that class is on.

     Closing on a link tap matters more than it looks: every nav item is a
     same-page anchor, so nothing navigates and nothing re-renders. Without it
     the panel would stay open on top of the section it had just scrolled to. */
  function menuIsOpen() { var n = $('#nav'); return !!n && n.classList.contains('open'); }
  function menuSet(open) {
    var btn = $('#menubtn'), nav = $('#nav');
    if (!btn || !nav) return;
    nav.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#menubtn')) { e.preventDefault(); menuSet(!menuIsOpen()); return; }
    if (!menuIsOpen()) return;
    // Everything else dismisses it: a nav link, the cart button, or the page behind.
    if (!e.target.closest('#nav') || e.target.closest('#nav a')) menuSet(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menuSet(false); });
  // The dropdown only exists below 880px. Left set, `.open` would put a stray
  // absolutely-positioned nav over the page as soon as the viewport widened.
  window.addEventListener('resize', function () {
    if (window.innerWidth > 880 && menuIsOpen()) menuSet(false);
  });

  /* ---------- init ---------- */
  function init() { refreshCart(); initReveal(); byobRender(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ---- PDP thumbnail rail -------------------------------------------------
   Swaps the main product image when a thumb is clicked. Delegated so it also
   works for markup Shopify re-renders (variant switches, section reloads), and
   it clears srcset — leaving a stale srcset makes the browser keep the old
   image on any viewport where srcset wins over src. */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-wac-thumb]');
  if (!t) return;
  var main = document.getElementById('pdp-main-img');
  if (!main) return;
  main.removeAttribute('srcset');
  main.removeAttribute('sizes');
  main.src = t.getAttribute('data-wac-thumb');
  t.closest('.pdp-thumbs').querySelectorAll('[data-wac-thumb]').forEach(function (b) {
    b.setAttribute('aria-current', b === t ? 'true' : 'false');
  });
});
